import { CreateChatMessage, CreateChatSession, GetChatSessionsByMetadata, UpdateChatMessage, UpdateChatSession } from "types";
import { axiosInstance } from "./axios";

export const createChatSession = async (data: CreateChatSession) => {
    try {
        return await axiosInstance.post(`user/create-session`, data);
    } catch (error) {
        throw error;
    }
};

export const updateChatSession = async (session_id: string, data: UpdateChatSession) => {
    try {
        return await axiosInstance.put(`user/sessions/${session_id}`, data);
    } catch (error) {
        throw error;
    }
};

export const getChatSessions = async (metadata: GetChatSessionsByMetadata) => {
    try {
        return await axiosInstance.post(`user/get-sessions`, metadata);
    } catch (error) {
        throw error;
    }
};

export const addNewMessage = async (data: CreateChatMessage) => {
    try {
        return await axiosInstance.post(`user/add-message`, data);
    } catch (error) {
        throw error;
    }
};

export const getSessionMessages = async (session_id: string) => {
    try {
        return await axiosInstance.get(`user/get-messages/${session_id}`);
    } catch (error) {
        throw error;
    }
};

export const updateChatMessage = async (message_id: string, data: UpdateChatMessage) => {
    try {
        return await axiosInstance.put(`user/messages/${message_id}`, data);
    } catch (error) {
        throw error;
    }
};

export const deleteChatMessage = async (message_id: string) => {
    try {
        return await axiosInstance.delete(`user/delete-message/${message_id}`);
    } catch (error) {
        throw error;
    }
};

export const updateRAGMessage = async (message_id: string, payload: any) => {
    try {
        return await axiosInstance.put(`user/mark-favorite/${message_id}`, payload);
    } catch (error) {
        throw error;
    }
};

export const pinTaskData = async (ragId: string, payload: any) => {
    try {
        return await axiosInstance.put(`user/pin-task-data/${ragId}`, payload);
    } catch (error) {
        throw error;
    }
}

export const updateLogistics = async (payload: UpdateChatMessage) => {
    try {
        return await axiosInstance.put(`user/update-logistics`, payload);
    } catch (error) {
        throw error;
    }
}

export const getLogistics = async (eventId: any) => {
    try {
        return await axiosInstance.get(`user/logistics/${eventId}`);
    } catch (error) {
        throw error;
    }
}